import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import Select from "react-select";
import { addNewR, uploadLogo } from "../../api/recruiter";
import { categoryPlanListAPI } from "../../api/plan";
import { roleMenuForRecruiterAPI } from "../../api/role";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const initialState = {
  plan_id: "",
  name: "",
  company_name: "",
  recruiter_email: "",
  recruiter_type: [],
  menus: ["1"],
  recruiter_password: "",
  publish: "0",
  actively_hiring: 0,
  plan_start_date: new Date(),
  job_posting_date: new Date(),
  resume_access_date: new Date(),
  company_logo: "",
  lgbt_confirmed: 0,
  nonlgbt: 0,
  nonlgbt_man: 0,
  nonlgbt_woman: 0,
};

const NewR = (props) => {
  const { addCard, setAddCard, dataFetch } = props;
  const [planlist, setPlanList] = useState([]);
  const [menulist, setMenuList] = useState([]);
  const [recruiterType] = useState([
    { value: 1, label: "Regular Recruiter" },
    { value: 2, label: "Internship Recruiter" },
  ]);
  const [addFormData, setAddFormData] = useState(initialState);
  const [startDate, setStartDate] = useState(new Date());
  const [jobPostingDate, setJobPostingDate] = useState(new Date());
  const [resumeAccessDate, setResumeAccessDate] = useState(new Date());

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    let plan = await categoryPlanListAPI();
    setPlanList(plan);
    let mdata = await roleMenuForRecruiterAPI();
    setMenuList(mdata);
  };

  const handleAddFormChange = (event) => {
    const fieldName = event.target.getAttribute("name");
    //console.log(fieldName, event.target.value);

    const fieldValue =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setAddFormData({ ...addFormData, [fieldName]: fieldValue });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const menuId = parseInt(name, 10); // Assuming the name attribute is the menu ID
    let updatedMenus = [...addFormData.menus];
    if (checked) {
      updatedMenus.push(menuId);
    } else {
      updatedMenus = updatedMenus.filter((menu) => menu !== menuId);
    }
    setAddFormData({ ...addFormData, menus: updatedMenus });
  };

  const handleRecruiterTypeChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    //console.log(selectedValues);

    setAddFormData({ ...addFormData, recruiter_type: selectedValues });
  };

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    let recType = addFormData?.recruiter_type;

    addFormData.plan_start_date = moment(startDate).format("yyyy-MM-DD");
    addFormData.resume_access_date =
      moment(resumeAccessDate).format("yyyy-MM-DD");
    addFormData.job_posting_date = moment(jobPostingDate).format("yyyy-MM-DD");

    if (
      !addFormData.name ||
      !addFormData.company_name ||
      !addFormData.recruiter_email ||
      addFormData.recruiter_type.length < 1 ||
      !addFormData.plan_id ||
      !addFormData.recruiter_password ||
      !addFormData.job_posting_date ||
      !addFormData.resume_access_date ||
      addFormData.menus.length === 0
    ) {
      error = true;
      errorMsg = "Please fill in all required fields";
    }

    //console.log(addFormData);

    //return;

    if (!error) {
      addFormData.recruiter_type = addFormData?.recruiter_type?.join(",");
      addFormData.status = addFormData.publish;
      let res = await addNewR(addFormData);
      if (res !== false) {
        if (res?.error) {
          setAddFormData({ ...addFormData, recruiter_type: recType });
          swal("Oops", res?.error, "error");
        } else {
          dataFetch(true);
          setAddCard(false);
          setAddFormData(initialState);
          swal("Successfully Added!", "Successfully Added", "success");
        }
      } else {
        setAddFormData({ ...addFormData, recruiter_type: recType });
        swal(
          "Oops",
          "Some problem occurs. Please contact administrator.",
          "error"
        );
      }
    } else {
      setAddFormData({ ...addFormData, recruiter_type: recType });
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAccessType = useCallback(
    (e, className) => {
      const data = {};
      const inputs = document.getElementsByClassName(className);
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked) {
            data[input.name] = 1;
          } else {
            if (input.name == "nonlgbt") {
              data["nonlgbt_man"] = 0;
              data["nonlgbt_woman"] = 0;
            }
            data[input.name] = 0;
          }
        } else {
          data[input.name] = input.value;
        }
      }
      setAddFormData((pre) => ({ ...pre, ...data }));
    },
    [setAddFormData]
  );

  //console.log(addFormData);

  const isFormValid = () => {
    return (
      addFormData.name &&
      addFormData.company_name &&
      addFormData.recruiter_email &&
      addFormData.recruiter_type.length > 0 &&
      addFormData.plan_id &&
      addFormData.recruiter_password &&
      //addFormData.job_posting_date &&
      //addFormData.resume_access_date &&
      addFormData.menus.length > 0
    );
  };

  const handleUploadImage = useCallback(
    (name, file) => {
      //setImageUploading({ uploding: true, name: name });
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        //error("Please upload file having extensions .jpeg/.jpg/.png only.");
        swal(
          "Oops",
          "Please upload file having extensions .jpeg/.jpg/.png only.",
          "error"
        );
        return false;
      }
      uploadLogo(file)
        .then((res) => {
          if (res.data?.data) {
            setAddFormData({
              ...addFormData,
              [name]: res.data?.data,
            });
          } else {
            console.log(res.data?.error);
          }
          //setImageUploading({ uploding: false, name: null });
        })
        .catch((err) => {
          //setImageUploading({ uploding: false, name: null });
          console.log(err);
        });
    },
    [addFormData, setAddFormData]
  );

  return (
    <Modal
      className="modal fade bd-example-modal-lg"
      show={addCard}
      onHide={() => setAddCard(false)}
      centered
      size="lg"
    >
      <div role="document">
        <div className="">
          <form autoComplete="off">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Add New Recruiter</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setAddCard(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Company Logo
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          name="company_logo"
                          onChange={(e) => {
                            handleUploadImage(
                              "company_logo",
                              e.target.files[0]
                            );
                          }}
                          //value={addFormData.name}
                          //onChange={handleAddFormChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Name <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={addFormData.name}
                          onChange={handleAddFormChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Company Name <sup>*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_name"
                          value={addFormData.company_name}
                          onChange={handleAddFormChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Email <sup>*</sup>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="recruiter_email"
                          value={addFormData.recruiter_email}
                          onChange={handleAddFormChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Password <sup>*</sup>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="recruiter_password"
                          autoComplete="off"
                          value={addFormData.recruiter_password}
                          onChange={handleAddFormChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Recruiter Type <sup>*</sup>
                        </label>
                        <Select
                          isMulti
                          options={recruiterType}
                          value={recruiterType.filter((type) =>
                            addFormData.recruiter_type.includes(type.value)
                          )}
                          onChange={handleRecruiterTypeChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Plan ID <sup>*</sup>
                        </label>
                        <select
                          className="form-select"
                          name="plan_id"
                          value={addFormData.plan_id}
                          onChange={handleAddFormChange}
                        >
                          <option value="">Select Plan</option>
                          {planlist.map((plan, i) => (
                            <optgroup key={i} label={plan.name}>
                              {plan.plans.map((pln) => (
                                <option key={pln.plan_id} value={pln.plan_id}>
                                  {pln.plan_name}
                                </option>
                              ))}
                            </optgroup>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Actively hiring
                        </label>
                        <select
                          className="form-select"
                          name="actively_hiring"
                          //value={addFormData.actively_hiring}
                          onChange={handleAddFormChange}
                        >
                          <option value="">Select </option>
                          <option value={1}>Yes</option>
                          <option value={0}>No</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Plan Start Date
                        </label>
                        <div>
                          <DatePicker
                            className={`form-control`}
                            dateFormat="Y-MM-dd"
                            minDate={new Date()}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select date"
                            onFocus={(e) => e.target.blur()}
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Job posting date
                        </label>
                        <div>
                          <DatePicker
                            className={`form-control`}
                            dateFormat="Y-MM-dd"
                            minDate={new Date()}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select date"
                            onFocus={(e) => e.target.blur()}
                            selected={jobPostingDate}
                            onChange={(date) => setJobPostingDate(date)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Resume access date
                        </label>
                        <div>
                          <DatePicker
                            className={`form-control`}
                            dateFormat="Y-MM-dd"
                            minDate={new Date()}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select date"
                            onFocus={(e) => e.target.blur()}
                            selected={resumeAccessDate}
                            onChange={(date) => setResumeAccessDate(date)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="text-black font-w500 mt-2">
                        Access type
                      </label>
                      <div className="contact-name">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input access_type"
                            type="checkbox"
                            name="lgbt_confirmed"
                            value="1"
                            id="lgbt_confirmed"
                            onChange={(e) => handleAccessType(e, "access_type")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="lgbt_confirmed"
                          >
                            LGBT Confirmed
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input access_type"
                            type="checkbox"
                            name="nonlgbt"
                            value="1"
                            id="nonlgbt"
                            onChange={(e) => handleAccessType(e, "access_type")}
                          />
                          <label className="form-check-label" htmlFor="nonlgbt">
                            Non LGBT+
                          </label>
                        </div>
                        {addFormData.nonlgbt === 1 && (
                          <>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt_man"
                                value="1"
                                id="nonlgbt_man"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt_man"
                              >
                                Man
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt_woman"
                                value="1"
                                id="nonlgbt_woman"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt_woman"
                              >
                                Woman
                              </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="text-black font-w500">Menus</label>
                        <div className="form-check">
                          {menulist.map((menu) => (
                            <div key={menu.id} className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={menu.id.toString()} // Use ID as name attribute
                                readOnly={menu.id === 1}
                                checked={
                                  addFormData.menus.includes(menu.id) ||
                                  menu.id === 1
                                }
                                onChange={handleCheckboxChange}
                              />
                              <label className="form-check-label">
                                {menu.menu_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Publish Status
                        </label>
                        <div>
                          <input
                            type="radio"
                            className="form-check-input"
                            name="publish"
                            value="1"
                            checked={addFormData.publish === "1"}
                            onChange={handleAddFormChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="publishActive"
                          >
                            Active &nbsp;&nbsp;&nbsp;
                          </label>
                          <input
                            type="radio"
                            className="form-check-input"
                            name="publish"
                            value="0"
                            checked={addFormData.publish !== "1"}
                            onChange={handleAddFormChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="publishInactive"
                          >
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-success"
                onClick={handleAddFormSubmit}
                //disabled={!isFormValid()}
              >
                Add
              </button>
              <button
                type="button"
                onClick={() => setAddCard(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Discard
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default NewR;
